import { render, staticRenderFns } from "./back_modal.vue?vue&type=template&id=6d8574d8&scoped=true"
import script from "./back_modal.vue?vue&type=script&lang=js"
export * from "./back_modal.vue?vue&type=script&lang=js"
import style0 from "./back_modal.vue?vue&type=style&index=0&id=6d8574d8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8574d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8574d8')) {
      api.createRecord('6d8574d8', component.options)
    } else {
      api.reload('6d8574d8', component.options)
    }
    module.hot.accept("./back_modal.vue?vue&type=template&id=6d8574d8&scoped=true", function () {
      api.rerender('6d8574d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/process/components/process_approve/back_modal.vue"
export default component.exports